import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Icon } from "@iconify/react";
import styles from "./ExplainerModal.module.css";

const ExplainerModal = ({ isOpen, onOpenStateChanged, title, content }) => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(isOpen);
  }, [isOpen]);

  return (
    <Modal isOpen={modalOpen} className="modal-lg" size="lg" toggle={() => setModalOpen(!modalOpen)}>
      <ModalHeader className={styles["modal-header"]}>
        <h4>{title}</h4>
      </ModalHeader>
      <ModalBody className={styles["modal-body"]}>
        {content}
      </ModalBody>
      <ModalFooter className={styles["modal-footer"]}>
        <Button style={{
          backgroundColor: "#036F36",
          color: "#FFF605",
          borderRadius: "2.25rem",
          width: "auto%",
          fontSize: "16px",
          fontWeight: "bold",
          padding: "10px",
          border: "none",
          margin: "0 auto",
        }}
          onClick={() => { setModalOpen(false); onOpenStateChanged(false); }}>
          Dismiss
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const Explainer = ({ previewContent, title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      {previewContent ? (
        <Button
          style={{
                backgroundColor: '#036F36',
                color: '#FFF605',
                borderRadius: '2.25rem',
                width: '100%',
              }}
          onClick={() => setIsOpen(!isOpen)}>
          {previewContent}
        </Button>
      ) : (
        <button className="btn homepage-explainer btn-primary" onClick={() => setIsOpen(!isOpen)}>
          <Icon icon="hugeicons:information-circle" />
        </button>
      )}
      <ExplainerModal isOpen={isOpen} onOpenStateChanged={setIsOpen} title={title} content={content} />
    </div>
  );
};

export default Explainer;
